export default "__VITE_ASSET__3pA4Md5i__"